export class Classifications {
  Class1: Classification[];
  Class2: Classification[];
  Class3: Classification[];
  Class4: Classification[];
}

export class ClassificationData {
  Data: Classification[];
  Count: number;
}

export class Classification {
  Id?: number;
  Uid?: string;
  SUid?: string;
  Name1?: string;
  Name2?: string;

  constructor(classification: Classification = {}) {
    this.Id = classification.Id;
    this.Uid = classification.Uid;
    this.SUid = classification.SUid;
    this.Name1 = classification.Name1;
    this.Name2 = classification.Name2;
  }
}
